import { render } from "./Muerto.vue?vue&type=template&id=337b4b2b"
import script from "./Muerto.vue?vue&type=script&lang=js"
export * from "./Muerto.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__